import { render, staticRenderFns } from "./vsSelectItem.vue?vue&type=template&id=2b02dca9&lang=html&"
import script from "./vsSelectItem.vue?vue&type=script&lang=js&"
export * from "./vsSelectItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsSelectItem.vue"
export default component.exports